export type BarChartSettings = {
  ticksCount: number
  labelY: string
  labelX: string
  barWidth: number
  intervalItemsCount: number
  hourlyDivider: number
  suggestedMax: number
  dataType: string
}

export const getBarChartSettings = (ticksCount?: number) => ({
  lastHour: {
    ticksCount: ticksCount || 1,
    labelY: "(minutes)",
    labelX: "Hours",
    barWidth: 0.4,
    intervalItemsCount: 60,
    hourlyDivider: 1,
    suggestedMax: 60,
    dataType: "minutes",
  },
  last6Hours: {
    ticksCount: ticksCount || 6,
    labelY: "(minutes)",
    labelX: "Hours",
    barWidth: 0.7,
    intervalItemsCount: 20,
    hourlyDivider: 1,
    suggestedMax: 60,
    dataType: "minutes",
  },
  last24Hours: {
    ticksCount: ticksCount || 24,
    labelY: "(minutes)",
    labelX: "Hours",
    barWidth: 0.7,
    intervalItemsCount: 6,
    hourlyDivider: 1,
    suggestedMax: 60,
    dataType: "minutes",
  },
  yesterday: {
    ticksCount: ticksCount || 24,
    labelY: "(minutes)",
    labelX: "Hours",
    barWidth: 0.7,
    intervalItemsCount: 6,
    hourlyDivider: 1,
    suggestedMax: 60,
    dataType: "minutes",
  },
  last3Days: {
    ticksCount: ticksCount || 3,
    labelY: "(hourly)",
    labelX: "Days",
    barWidth: 0.5,
    intervalItemsCount: 48,
    hourlyDivider: 60,
    suggestedMax: 24,
    dataType: "hourly",
  },
  last7Days: {
    ticksCount: ticksCount || 7,
    labelY: "(hourly)",
    labelX: "Days",
    barWidth: 0.7,
    intervalItemsCount: 24,
    hourlyDivider: 60,
    suggestedMax: 24,
    dataType: "hourly",
  },
  last30Days: {
    ticksCount: ticksCount || 30,
    labelY: "(hourly)",
    labelX: "Days",
    barWidth: 0.7,
    intervalItemsCount: 6,
    hourlyDivider: 60,
    suggestedMax: 24,
    dataType: "hourly",
  },
  custom: {
    ticksCount: ticksCount || 0,
    labelY: "(hourly)",
    labelX: "Days",
    barWidth: 0.7,
    intervalItemsCount: 6,
    hourlyDivider: 60,
    suggestedMax: 24,
    dataType: "hourly",
  },
})
